/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerFileTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for File Types
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, December 02, 2018 - 05:56:06 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      12/02/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    FILETYPE_LIST_CONTAINER_LOADED,
    FILETYPE_LIST_CONTAINER_UNLOADED,
    FILETYPE_LIST_TABLE_LOADED,
    FILETYPE_LIST_TABLE_UNLOADED,

    FILETYPE_SELECT_ROW,
    FILETYPE_ADD,
    FILETYPE_EDIT,
    FILETYPE_DELETE,
    FILETYPE_OPEN_WARNING,
    FILETYPE_CLOSE_WARNING,

    FILETYPE_EDIT_CONTAINER_LOADED,
    FILETYPE_EDIT_CONTAINER_UNLOADED,
    FILETYPE_EDIT_FORM_LOADED,
    FILETYPE_EDIT_FORM_UNLOADED,
    FILETYPE_EDIT_DATA_LOAD,
    FILETYPE_EDIT_CONTAINER_SUBMIT,
    FILETYPE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeFileTypes';

const defaultState = {
    refreshList: false,
    danger: false,
    filetypeid: 0,
    name: '',
    description: '',
    extension: '',
    contenttype: '',
    url: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FILETYPE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                filetypes: action.payload[0] ? action.payload[0].records : null
            }
        case FILETYPE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case FILETYPE_SELECT_ROW:
            return {
                ...state,
                filetypeid: action.id
            }
        case FILETYPE_ADD:
            return {
                ...state
            }
        case FILETYPE_EDIT:
            return {
                ...state,
                filetypeid: action.id
            }
        case FILETYPE_DELETE:
            return {
                ...state,
                filetypeid: null
            }
        case FILETYPE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case FILETYPE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case FILETYPE_EDIT_CONTAINER_LOADED:
        case FILETYPE_EDIT_DATA_LOAD:
            return {
                ...state,
                filetypeid: action.payload[0] ? action.payload[0].filetypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                extension: action.payload[0] ? action.payload[0].extension : '',
                contenttype: action.payload[0] ? action.payload[0].contenttype : '',
                url: action.payload[0] ? action.payload[0].url : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case FILETYPE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case FILETYPE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case FILETYPE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case FILETYPE_LIST_CONTAINER_UNLOADED:
        case FILETYPE_LIST_TABLE_UNLOADED:
        case FILETYPE_EDIT_CONTAINER_UNLOADED:
        case FILETYPE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerFileTypes.js